import { useEffect, useRef } from 'react';
import { useAuth } from '../auth';

const ADS_ENABLED = import.meta.env.VITE_ADS_ENABLED === 'true';
const ADSENSE_CLIENT = import.meta.env.VITE_ADSENSE_CLIENT || '';

export const AD_SLOTS = {
  home: import.meta.env.VITE_ADSENSE_SLOT_HOME || '',
  gameEnd: import.meta.env.VITE_ADSENSE_SLOT_GAME_END || '',
  daily: import.meta.env.VITE_ADSENSE_SLOT_DAILY || '',
} as const;

interface Props {
  slot?: string;
  format?: string;
  layout?: 'horizontal' | 'vertical' | 'rectangle';
  style?: React.CSSProperties;
}

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

/**
 * Google AdSense banner. Premium kullanıcılarda hiçbir şey render etmez.
 * `VITE_ADSENSE_CLIENT` env tanımlı değilse de render etmez (dev guard).
 */
export function AdBanner({ slot = '', format = 'auto', layout = 'horizontal', style }: Props) {
  const { user } = useAuth();
  const insRef = useRef<HTMLModElement>(null);

  useEffect(() => {
    if (!ADS_ENABLED) return;
    if (!ADSENSE_CLIENT || !slot) return;
    if (user?.is_premium) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* ignore */
    }
  }, [user?.is_premium, slot]);

  if (!ADS_ENABLED) return null;
  if (user?.is_premium) return null;
  if (!ADSENSE_CLIENT || !slot) return null;

  const dims: React.CSSProperties = {
    display: 'block',
    width: '100%',
    minHeight: layout === 'vertical' ? 250 : 90,
    textAlign: 'center',
    ...style,
  };

  return (
    <ins
      ref={insRef}
      className="adsbygoogle"
      style={dims}
      data-ad-client={ADSENSE_CLIENT}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
}
